module.exports = __webpack_public_path__ + "static/media/locationRed.3d0c5526.svg";